module.exports = __webpack_public_path__ + "img/Google@2x.7422966c.png";